<template>
  <div>
    <!-- dekstop -->
    <b-form class="d-none d-sm-block">
      <b-form-row class="justify-content-center">
        <b-col cols="10" class="center-base">
          <h2 style="white-space: nowrap; margin-top: 0.75rem;">Guide me in&emsp;</h2>
          <model-select
            style="font-size: 22px; font-weight: 600;"
            placeholder="Destination"
            v-model="city"
            :options="destination_options"
          />
        </b-col>
      </b-form-row>

      <b-form-row class="my-2">
        <!-- <b-col>
          <hr style="border-bottom: 1px solid #dddddd;">
        </b-col> -->
      </b-form-row>

      <b-form-row>
        <b-col cols="3" offset="1">
          <v-date-picker
            mode='single'
            is-expanded
            title-position="left"
            :input-props='{
              placeholder: "Date"
            }'

            v-model='date'
            :min-date='min_date'
            :max-date='max_date'
          />
        </b-col>
        <b-col cols="3">
          <b-input-group append="Day">
            <b-form-select v-model="duration" :options="duration_options" />
          </b-input-group>
        </b-col>
        <b-col cols="4">
          <InputSelect
            @passToParent="childData"
            :val="interest"
            id="interest"
            text="Interest"
            :options="interest_options"
            hide_label=true
          />
        </b-col>
      </b-form-row>
      <b-form-row class="justify-content-center">
        <b-col cols="10" class="mt-1">
          <i v-if="date_description">Tour Date: {{ date_description }}</i>
          <i v-else>Tour Date: -</i>
        </b-col>
      </b-form-row>

      <b-form-row class="justify-content-center mt-2">
        <b-col class="center-base all">
          <div
            v-for="(so, i) in service_options.slice(0,4)"  :key="i"
            class="service-select"
            :class="service === so.text ? 'selected' : null"
            @mouseover="mouseover(so.text)"
            @mouseleave="mouseoutService"
            @click="setService(so.text)"
          >
            <b-img
              :src="require(`@/assets/icon/services/${so.text.toLowerCase()}.png`)"
              fluid
            />
          </div>
        </b-col>
      </b-form-row>
      <b-form-row class="justify-content-center mt-1">
        <b-col class="center-base all">
          <div
            v-for="(so, i) in service_options.slice(4,8)"  :key="i"
            class="service-select"
            :class="service === so.text ? 'selected' : null"
            @mouseover="mouseover(so.text)"
            @mouseleave="mouseoutService"
            @click="setService(so.text)"
          >
            <b-img
              :src="require(`@/assets/icon/services/${so.text.toLowerCase()}.png`)"
              fluid
            />
          </div>
        </b-col>
      </b-form-row>
      <b-form-row class="mt-2 justify-content-center">
        <b-col cols="10">
          <i>{{ service_description }}</i>
        </b-col>
      </b-form-row>

      <b-form-row class="justify-content-end mt-3">
        <b-col cols="4">
          <b-button class="order-button" block @click="submitOrder" :disabled="order_button_state">
            <font-awesome-icon icon="search" />
            Search
          </b-button>
        </b-col>
      </b-form-row>
    </b-form>

    <!-- mobile -->
    <b-form class="py-3 d-block d-sm-none">
      <b-form-row class="justify-content-center">
        <b-col cols="10" class="center-base">
          <model-select
            style="font-size: 16px; font-weight: 600;"
            placeholder="Destination"
            v-model="city"
            :options="destination_options"
          />
        </b-col>
      </b-form-row>

      <b-form-row class="mt-3">
        <b-col cols="5" offset="1">
          <v-date-picker
            mode='single'
            is-expanded
            title-position="left"
            :input-props='{
              placeholder: "Date"
            }'

            v-model='date'
            :min-date='min_date'
            :max-date='max_date'
          />
        </b-col>
        <b-col cols="5">
          <b-input-group append="Day">
            <b-form-select v-model="duration" :options="duration_options" />
          </b-input-group>
        </b-col>
      </b-form-row>
      <b-form-row class="justify-content-center">
        <b-col cols="10">
          <i v-if="date_description" style="font-size: 14px;">Tour Date: {{ date_description }}</i>
          <i v-else style="font-size: 14px;">Tour Date: -</i>
        </b-col>
      </b-form-row>

      <b-form-row class="mt-3">
        <b-col cols="10" offset="1">
          <InputSelect
            @passToParent="childData"
            :val="interest"
            id="interest"
            text="Interest"
            :options="interest_options"
            hide_label=true
          />
        </b-col>
      </b-form-row>

      <b-form-row class="justify-content-center mt-4">
        <b-col class="center-base all">
          <div
            v-for="(so, i) in service_options.slice(0,4)"  :key="i"
            class="service-select"
            :class="service === so.text ? 'selected' : null"
            @mouseover="mouseover(so.text)"
            @mouseleave="mouseoutService"
            @click="setService(so.text)"
          >
            <b-img
              :src="require(`@/assets/icon/services/${so.text.toLowerCase()}.png`)"
              fluid
            />
          </div>
        </b-col>
      </b-form-row>
      <b-form-row class="justify-content-center mt-2">
        <b-col class="center-base all">
          <div
            v-for="(so, i) in service_options.slice(4,8)"  :key="i"
            class="service-select"
            :class="service === so.text ? 'selected' : null"
            @mouseover="mouseover(so.text)"
            @mouseleave="mouseoutService"
            @click="setService(so.text)"
          >
            <b-img
              :src="require(`@/assets/icon/services/${so.text.toLowerCase()}.png`)"
              fluid
            />
          </div>
        </b-col>
      </b-form-row>
      <b-form-row class="mt-2 justify-content-center">
        <b-col cols="10">
          <i>{{ service_description }}</i>
        </b-col>
      </b-form-row>

      <b-form-row class="justify-content-end mt-3">
        <b-col cols="6">
          <b-button class="order-button" block @click="submitOrder" :disabled="order_button_state">
            <font-awesome-icon icon="search" />
            Search
          </b-button>
        </b-col>
      </b-form-row>
    </b-form>
  </div>
</template>

<script>
// external dependencies
import swal from 'sweetalert'
import VueJwtDecode from 'vue-jwt-decode'
import { ModelSelect } from 'vue-search-select'
import moment from 'moment'

// custom component
import InputSelect from '@/templates/InputSelect'

// api call
import AdminCountryAPI from '@/api/AdminCountryAPI'
import AdminInterestAPI from '@/api/AdminInterestAPI'
import AdminServiceAPI from '@/api/AdminServiceAPI'

export default {
  name: 'FormOrder',
  components: {
    ModelSelect,
    InputSelect
  },
  data () {
    return {
      country: null,
      city: null,
      destination_options: [],

      date: {},
      min_date: new Date(moment().startOf('day').format('l')), // min today
      max_date: new Date(moment().startOf('day').add(365, 'days').format('l')), // max 1 year from today
      date_description: '',

      duration: 1,
      duration_options: [
        { value: null, text: 'Duration', disabled: true },
        { value: 1, text: '1' },
        { value: 2, text: '2' },
        { value: 3, text: '3' },
        { value: 4, text: '4' },
        { value: 5, text: '5' },
        { value: 6, text: '6' },
        { value: 7, text: '7' },
        { value: 8, text: '8' },
        { value: 9, text: '9' },
        { value: 10, text: '10' },
        { value: 11, text: '11' },
        { value: 12, text: '12' },
        { value: 13, text: '13' },
        { value: 14, text: '14' },
        { value: 15, text: '15' },
        { value: 16, text: '16' },
        { value: 17, text: '17' },
        { value: 18, text: '18' },
        { value: 19, text: '19' },
        { value: 20, text: '20' },
        { value: 21, text: '21' },
        { value: 22, text: '22' },
        { value: 23, text: '23' },
        { value: 24, text: '24' },
        { value: 25, text: '25' },
        { value: 26, text: '26' },
        { value: 27, text: '27' },
        { value: 28, text: '28' },
        { value: 29, text: '29' },
        { value: 30, text: '30' },
        { value: 31, text: '31' }
      ],

      interest: null,
      interest_options: [],

      service_id: null,
      service: null,
      service_description: '',
      service_options: [],

      order_button_state: false,
      errors: []
    }
  },
  beforeCreate: function () {
    // get session data
    if (this.$session.get('jwt') && this.$session.exists()) {
      let decode = VueJwtDecode.decode(this.$session.get('jwt'))
      this.user = decode
    } else {
      this.user = null
    }
  },
  mounted: function () {
    // get options data
    this.fetchAllCountry()
    this.fetchAllInterest()
    this.fetchServiceByCountry('5ccd68bcba49fad2ae76ee2f') // default country_id: france
  },
  watch: {
    city: function (val) {
      // set country name
      this.destination_options.forEach(destination => {
        if (destination.value === val) {
          this.country = destination.sgms_country_id

          // set service based on country
          this.fetchServiceByCountry(destination.sgms_country_id)
        }
      })
    },
    // re-calculate on date & duration changes
    date: function (val) {
      this.setDateDescription()
    },
    duration: function (val) {
      this.setDateDescription()
    }
  },
  methods: {
    // PREREQUISITES
    childData: function (id, value) {
      // catch value from custom form template
      this[id] = value
    },
    mouseoutService: function () {
      this.service_options.forEach(service => {
        if (service.text === this.service) {
          this.service_description = service.description.join(' ')
        }
      })
    },
    mouseover: function (selected) {
      this.service_options.forEach(service => {
        if (service.text === selected) {
          this.service_description = service.description.join(' ')
        }
      })
    },
    setService: function (selected) {
      this.service = selected

      // set service description
      this.service_options.forEach(service => {
        if (service.text === selected) {
          this.service_id = service.value
          this.service_description = service.description.join(' ')
        }
      })
    },
    setDateDescription: function () {
      let sd, ed
      sd = moment(this.date) // convert date-picker -> moment
      ed = moment(sd).add(this.duration - 1, 'days')

      if (this.duration - 1 === 0) this.date_description = `${moment(sd).format('ll')} (${this.duration} Day)`
      else this.date_description = `${moment(sd).format('ll')} - ${moment(ed).format('ll')} (${this.duration} Days)`
    },
    // END PREREQUISITES

    // HTTP REQUEST
    fetchAllCountry: async function () {
      const response = await AdminCountryAPI.fetchAll()

      response.data.country.forEach(country => {
        this.destination_options.push({ value: country.country_name, text: '-- ' + country.country_name + ' --', disabled: true })

        country.city.forEach(city => {
          this.destination_options.push({ value: city._id, text: city.city_name, sgms_country_id: country._id })
        })
      })
    },
    fetchAllInterest: async function () {
      this.interest_options.push({ value: null, text: 'Choose Interest', disabled: true })

      const response = await AdminInterestAPI.fetchAll()
      response.data.interest.forEach(interests => {
        this.interest_options.push({ value: interests._id, text: interests.interest })
      })
    },
    fetchServiceByCountry: async function (countryId) {
      this.service_options = [] // because fetchServiceByCountry is called multiple time

      const response = await AdminServiceAPI.fetchByCountry({ sgms_country_id: countryId })
      response.data.service.forEach(service => {
        this.service_options.push({ value: service._id, text: service.sgms_service_type_id.service_name, description: service.sgms_service_type_id.description })
      })

      this.setService('StarX')
    },
    submitOrder: async function () {
      this.order_button_state = true
      this.errors = []

      if (!this.city) { this.errors.push('Where do you want to go?') }
      if (!this.date) { this.errors.push('When do you want to travel?') }

      if (this.errors.length) {
        swal({
          title: 'Whoops!.',
          text: this.errors[0],
          icon: 'error',
          button: {
            text: 'Ok'
          }
        })
        this.order_button_state = false
      } else {
        // save order data
        this.$cookies.set('order_data', {
          country: this.country,
          city: this.city,

          start_date: moment(this.date).format('DD/MM/YYYY'),
          end_date: moment(this.date).add(this.duration - 1, 'days').format('DD/MM/YYYY'),
          duration: this.duration,
          service: this.service_id,
          interest: [ this.interest ]
        })

        if (this.user) {
          this.$router.push({ name: 'Order' })
        } else {
          this.$router.push({
            name: 'Login',
            params: {
              whereTo: 'Order'
            }
          })
        }
      }
    }
    // END HTTP REQUEST
  }
}
</script>

<style scope>
  .service-select {
    width: 100px;
    height: 100px;
    border-radius: 10px;
    background-color: #fafafa;
    border: 3px solid #dddddd;

    cursor: pointer;

    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;

    padding: 0.25rem !important;
    margin: 0.25rem 0.5rem !important;
  }

  .service-select:hover {
    color: #ffffff;
    background-color: #c8cede;
  }

  .service-select.selected {
    color: #ffffff;
    background-color: #c8cede;
    border: 3px solid #233c7c;
    font-weight: 600;
  }

  .sg-input-group .input-icon {
    background-color: white !important;
    border-right: 0px;
  }
  .sg-input-group .input-type {
    border-left: 0px;
  }

  .sg-form-title {
    color: #233c7c;
    font-size: 25px;
    font-weight: 600;
  }

  .order-button {
    font-weight: 900 !important;
    font-size: 20px !important;

    color: white !important;
    background-color: #f27137 !important;
    border-color: #f27137 !important;
  }
  .order-button:hover {
    background-color: #ffa274 !important;
    border-color: #ffa274 !important;
  }

  .swal-modal {
    border-radius: 15px;
  }
  .swal-button {
    border-radius: 10px;
  }
  .swal-button {
    background-color: #3e5d8f !important;
  }
  .swal-button:hover {
    background-color: #869ab9 !important;
  }
  .swal-footer {
    text-align: center;
  }
  .swal-overlay {
    background-color: #56719d80;
  }
</style>



// WEBPACK FOOTER //
// src/templates/FormOrder/FormOrder.vue